import React, { useState } from "react";
import Slider from "react-slick";
import useStyles, { FormInputSelect } from "./styles";
import Navbar2 from "../../components/Navbar2/Navbar2";
import Section from "../../components/Section/Section";
import Footer from "../../components/Footer/Footer";
import FormInputNoLabel from "../../components/FormInputNoLabel/FormInputNoLabel";
import Paragraph from "../../components/Typography/Paragraph";
import Card from "../../components/Card/Card";
import Loader from "react-js-loader";

import giftbox from "../../assets/images/giftbox.png";
import wallet from "../../assets/images/wallet.png";
import slot from "../../assets/images/slot.png";
import result from "../../assets/images/result.png";
import event from "../../assets/images/event.png";
import subscribe from "../../assets/images/subscribe.png";

import {
  Container,
  Grid,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Collapse,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  RadioGroup,
  Radio,
  FormControlLabel,
  TablePagination,
  Stack,
  Checkbox,
} from "@mui/material";
import Button from "../../components/Button/Button";
import {
  AddCircle,
  ExitToApp,
  ShareOutlined,
  Storefront,
  Twitter,
  Upload,
  WarehouseOutlined,
} from "@mui/icons-material";
import {
  get_customer_detail,
  get_orders_history_admin,
  edit_address_admin,
  add_address_admin,
  delete_address,
  get_country,
  get_state,
  get_topup_history,
  get_customer_invoice,
  validate_state,
  get_customer_credit_note,
  get_sales_order_report,
  get_return_status,
  get_statement,
  get_customer_report_data,
} from "../../API/API";
import Countdown from "react-countdown";
import moment from "moment/moment";

import "./styles.css";
import FormInput from "../../components/FormInput/FormInput";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import toast from "react-simple-toasts";
import useUser from "../../hooks/useUser";

export default function CustomerDetail() {
  const classes = useStyles();
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();

  const { set_user, get_user } = useUser();

  const [sort, setSort] = React.useState(0);
  const [page, setPage] = useState("User Information");
  const [open, setOpen] = React.useState(false);
  const [countryData, setCountryData] = React.useState([]);
  const [stateData, setStateData] = React.useState([]);
  const [addressData, setAddressData] = React.useState({
    contact_name: "",
    contact_number: "",
    addr1: "",
    addr2: "",
    city: "",
    // zip: "",
    // state: "",
    country: "",
    customer_address_id: "",
  });
  const [openDelete, setOpenDelete] = React.useState(false);
  const [selectedAddress, setSelectedAddress] = React.useState(null);
  const [openAdd, setOpenAdd] = React.useState(false);
  const [addressAddData, setAddressAddData] = React.useState({
    contact_name: "",
    contact_number: "",
    addr1: "",
    addr2: "",
    city: "",
    zip: "",
    state: 0,
    country: 0,
  });

  const handleChangeSort = (event) => {
    setSort(event.target.value);
  };

  const [searchKey, setSearchKey] = React.useState("");
  const [debouncedSearchKey, setDebouncedSearchKey] = React.useState("");
  const searchTimeoutRef = React.useRef(null);

  const handleSearch = (event) => {
    const value = event.target.value;
    setSearchKey(value);
    
    // Clear previous timeout
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }
    
    // Set new timeout to update debouncedSearchKey after user stops typing (500ms)
    searchTimeoutRef.current = setTimeout(() => {
      setDebouncedSearchKey(value);
    }, 500);
  };

  const fetchOrdersHistory = (pageNum = 1, customerName = "") => {
    setLoadingOrdersHistory(true);
    const apiParams = {
      customer_id: params.customer_id,
      page: pageNum,
    };
    if (customerName && customerName.trim() !== "") {
      apiParams.customer_name = customerName.trim();
    }
    get_orders_history_admin(apiParams).then((json) => {
      setcustomerHistory(json.data || []);
      setOrdersHistoryTotal(json.total || 0);
      setLoadingOrdersHistory(false);
    }).catch((error) => {
      setLoadingOrdersHistory(false);
    });
  };

  const [totalList, setTotalList] = React.useState(1);
  const [pageNum, setPageNum] = React.useState(0);

  const [loading, setLoading] = useState(false);
  const [customerDetail, setCustomerDetail] = React.useState(null);
  // console.log(customerDetail.contact)
  const [customerHistory, setcustomerHistory] = React.useState([]);
  const [topupHistory, settopupHistory] = React.useState(null);
  const [invoiceList, setinvoiceList] = React.useState(null);
  const [customerNoteList, setCustomerNoteList] = React.useState(null);
  const [zipStatus, setZipStatus] = React.useState(false);
  const [zipStatusEdit, setZipStatusEdit] = React.useState(false);
  const [ordersHistoryPageNum, setOrdersHistoryPageNum] = React.useState(0);
  const [ordersHistoryTotal, setOrdersHistoryTotal] = React.useState(0);
  const [loadingOrdersHistory, setLoadingOrdersHistory] = React.useState(false);

  const getData = () => {
    setLoading(true);
    setOrdersHistoryPageNum(0);
    get_country({}).then((json) => {
      setCountryData(json.data);
      // setTotalList(json.total);
    });
    get_state({}).then((json) => {
      setStateData(json.data);
      // setTotalList(json.total);
    });
    get_customer_detail({
      customer_id: params.customer_id,
      // sort: sort
    }).then((json) => {
      setLoading(false);
      setCustomerDetail(json.data);
      // setTotalList(json.total);
    });
    fetchOrdersHistory(1, "");
    get_topup_history({
      customer_id: params.customer_id,
      // sort: sort
    }).then((jsonth) => {
      // setLoading(false);
      settopupHistory(jsonth.data);
      // setTotalList(json.total);
    });
    get_customer_invoice({
      customer_id: params.customer_id,
      page: 1,
      // sort: sort
    }).then((jsonci) => {
      // setLoading(false);
      setinvoiceList(jsonci.data);
      setTotalList(jsonci.total);
    });
    get_customer_credit_note({
      customer_id: params.customer_id,
      // sort: sort
    }).then((jsoncn) => {
      // setLoading(false);
      setCustomerNoteList(jsoncn.data);
      // setTotalList(json.total);
    });
  };

  React.useEffect(() => {
    getData();
  }, []);

  const handleChangeOrdersHistoryPage = (e, newPage) => {
    setOrdersHistoryPageNum(newPage);
    fetchOrdersHistory(newPage + 1, debouncedSearchKey);
  };

  React.useEffect(() => {
    if (window.localStorage.getItem("page") === "Order History") {
      setOrdersHistoryPageNum(0);
      fetchOrdersHistory(1, debouncedSearchKey);
    }
  }, [debouncedSearchKey]);

  // Cleanup timeout on unmount
  React.useEffect(() => {
    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, []);

  // React.useEffect(() => {
  //     getData();
  // }, [pageNum, sort]);

  const handleChangePage = (e, ispage) => {
    setPageNum(ispage);
    // getData();
  };

  const [selectedState, setSelectedState] = React.useState({
    state: "",
    zip: "",
  });
  const [zipCode, setZipCode] = React.useState("");

  const handleOpen = (e) => {
    setOpen(true);
    setAddressData({
      contact_name: e.contact_name,
      contact_number: e.contact_number,
      addr1: e.addr1,
      addr2: e.addr2,
      city: e.city,
      // zip: e.zip,
      // state: e.state,
      country: e.country,
      customer_address_id: e.customer_address_id,
    });
    setSelectedState({
      state: e.state,
      zip: e.zip,
    });
    // setZipCode(e.zip);
    // console.log(e.state);
  };
  const handleClose = (value) => {
    setOpen(false);
  };

  const handleCheckValid = (e) => {
    setSelectedState({
      ...selectedState,
      [e.target.name]: e.target.value,
    });

    if (e.target.name == "state") {
      validate_state({ zip: selectedState.zip, state: e.target.value }).then(
        (json) => {
          if (json.status) {
            setZipStatusEdit(false);
          } else {
            setZipStatusEdit(true);
          }
        }
      );
    }

    if (e.target.name == "zip") {
      validate_state({ zip: e.target.value, state: selectedState.state }).then(
        (json) => {
          if (json.status) {
            setZipStatusEdit(false);
          } else {
            setZipStatusEdit(true);
          }
        }
      );
    }
  };

  React.useEffect(() => {}, []);

  const handleChangeAddress = (e) => {
    setAddressData({
      ...addressData,
      [e.target.name]: e.target.value,
    });
    // if (e.target.name == "zip") {
    //   validate_state({
    //     zip: e.target.value,
    //     state: addressAddData.state,
    //     // sort: sort
    //   }).then((jsonth) => {
    //     if (jsonth.status) {
    //       setZipStatusEdit(false);
    //     } else {
    //       setZipStatusEdit(true);
    //     }
    //   });
    //   return;
    // }
    // if (e.target.name == "state") {
    //   validate_state({
    //     state: e.target.value,
    //     zip: addressAddData.zip,
    //     // sort: sort
    //   }).then((jsonth) => {
    //     if (jsonth.status) {
    //       setZipStatusEdit(false);
    //     } else {
    //       setZipStatusEdit(true);
    //     }
    //   });
    //   return;
    // }
  };
  const handleSaveAddress = () => {
    if (addressData.contact_name.length == 0) {
      toast("Please enter contact name");
      return;
    }
    if (addressData.contact_number.length == 0) {
      toast("Please enter contact number");
      return;
    }
    if (addressData.addr1.length == 0) {
      toast("Please enter address 1");
      return;
    }
    if (addressData.addr2.length == 0) {
      toast("Please enter address 2");
      return;
    }
    if (addressData.city.length == 0) {
      toast("Please enter city");
      return;
    }
    if (selectedState.zip.length == 0) {
      toast("Please enter zipcode");
      return;
    }
    if (selectedState.state.length == 0) {
      toast("Please enter state");
      return;
    }
    if (addressData.country == 0) {
      toast("Please select country");
      return;
    }

    let postparam = {
      ...addressData,
      state: selectedState.state,
      zip: selectedState.zip,
    };

    setLoading(true);
    edit_address_admin(postparam).then((json) => {
      if (json.status) {
        setLoading(false);
        toast("Address Edit Succcessful");
        handleClose();
        getData();
      } else {
        setLoading(false);
        toast(json.message);
      }
    });
  };

  const handleOpenDelete = (e) => {
    setOpenDelete(true);
    setSelectedAddress(e);
  };
  const handleCloseDelete = (value) => {
    setOpenDelete(false);
  };
  const handleDeleteAddress = () => {
    setLoading(true);
    delete_address({ customer_address_id: selectedAddress }).then((json) => {
      if (json.status) {
        setLoading(false);
        toast("Address Deleted");
        handleCloseDelete();
        getData();
      } else {
        setLoading(false);
        toast(json.message);
      }
    });
  };

  const handleOpenAdd = (e) => {
    setOpenAdd(true);
  };
  const handleCloseAdd = (value) => {
    setOpenAdd(false);
  };

  const handleChangeAddAddress = (e) => {
    setAddressAddData({
      ...addressAddData,
      [e.target.name]: e.target.value,
    });
    if (e.target.name == "zip") {
      validate_state({
        zip: e.target.value,
        state: addressAddData.state,
        // sort: sort
      }).then((jsonth) => {
        if (jsonth.status) {
          setZipStatus(false);
        } else {
          setZipStatus(true);
        }
      });
      return;
    }
    if (e.target.name == "state") {
      validate_state({
        state: e.target.value,
        zip: addressAddData.zip,
        // sort: sort
      }).then((jsonth) => {
        if (jsonth.status) {
          setZipStatus(false);
        } else {
          setZipStatus(true);
        }
      });
      return;
    }
  };
  const handleAddAddress = () => {
    if (addressAddData.contact_name.length == 0) {
      toast("Please enter contact name");
      return;
    }
    if (addressAddData.contact_number.length == 0) {
      toast("Please enter contact number");
      return;
    }
    if (addressAddData.addr1.length == 0) {
      toast("Please enter address 1");
      return;
    }
    if (addressAddData.addr2.length == 0) {
      toast("Please enter address 2");
      return;
    }
    if (addressAddData.city.length == 0) {
      toast("Please enter city");
      return;
    }
    if (addressAddData.zip.length == 0) {
      toast("Please enter zipcode");
      return;
    }
    if (addressAddData.state == 0) {
      toast("Please select state");
      return;
    }
    if (addressAddData.country == 0) {
      toast("Please select country");
      return;
    }
    setLoading(true);
    add_address_admin({
      ...addressAddData,
      customer_id: customerDetail.customer_id,
    }).then((json) => {
      if (json.status) {
        setLoading(false);
        toast("Address Add Succcessful");
        handleCloseAdd();
        getData();
        setAddressAddData({
          contact_name: "",
          contact_number: "",
          addr1: "",
          addr2: "",
          city: "",
          zip: "",
          state: 0,
          country: 0,
        });
      } else {
        setLoading(false);
        toast(json.message);
      }
    });
  };

  // SALE REPORT

  const [sortSaleReport, setSortSaleReport] = React.useState(0);
  const [allData, setAllData] = React.useState([]);

  const handleChangeSortSaleReport = (event) => {
    setSort(event.target.value);
  };

  const [searchKeySaleReport, setSearchKeySaleReport] = React.useState("");
  // const [searchKeyStatus, setSearchKeyStatus] = React.useState("");

  const searchData = (data, searchKey) => {
    var _data = [];
    if (searchKey != "") {
      for (var i = 0; i < data.length; i++) {
        if (
          data[i].sales_order_id
            .toUpperCase()
            .indexOf(searchKey.toUpperCase()) > -1
        ) {
          _data.push(data[i]);
        }
      }
    } else {
      _data = [...data];
    }

    return _data;
  };

  const handleSearchSaleReport = (event) => {
    setSearchKey(event.target.value);
    var _data = searchData(allData, event.target.value);
    setListData(_data);
    setPageNum(0);
    setTotalListSaleReport(_data.length);
  };

  const [returnStatus, setReturnStatus] = React.useState([]);

  const getStatus = () => {
    get_return_status().then((json) => {
      setReturnStatus(json.data);
    });
  };

  React.useEffect(() => {
    getStatus();
  }, []);
  const [selectedStatus, setSelectedStatus] = React.useState("Open");

  const handleChooseStatus = (e) => {
    setSelectedStatus(e.target.value);
    window.localStorage.setItem("issuelog_status", e.target.value);
  };

  const [dateFrom, setDateFrom] = React.useState("");

  const handleChangeDateFrom = (event) => {
    const value = event.target.value;
    setDateFrom(value);
    window.localStorage.setItem("issuelog_datefrom", value);
  };

  const [dateTo, setDateTo] = React.useState("");

  const handleChangeDateTo = (event) => {
    const value = event.target.value;
    setDateTo(value);
    window.localStorage.setItem("issuelog_dateto", value);
  };

  // const [loading, setLoading] = React.useState(false);
  const [totalListSaleReport, setTotalListSaleReport] = React.useState(1);
  const [pageNumSaleReport, setPageNumSaleReport] = React.useState(0);
  const [imageData, setImageData] = React.useState(null);
  const [openVariantImg, setOpenVariantImg] = React.useState(false);
  const [infiniteStatus, setInfiniteStatus] = React.useState(true);

  const handleOpenVariantImage = (e) => {
    // console.log(e)
    if (e.length < 5) {
      setInfiniteStatus(false);
    } else {
      setInfiniteStatus(true);
    }
    setOpenVariantImg(true);
    setImageData(e);
  };
  const handleCloseVariantImage = (value) => {
    setOpenVariantImg(false);
    setImageData(null);
  };

  const [listData, setListData] = React.useState(null);

  const getDataSaleReport = () => {
    setLoading(true);
    get_customer_report_data({
      page: 1,
      dateFrom: dateFrom,
      dateTo: dateTo,
      status: selectedStatus,
      customer_id: params.customer_id,
      // sort: sort
    }).then((json) => {
      setLoading(false);
      setAllData(json.data);
      var _data = searchData(json.data, searchKey);
      setListData(_data);
      setTotalListSaleReport(_data.length);
    });
  };

  React.useEffect(() => {
    getDataSaleReport();
    const storedStatus = window.localStorage.getItem("issuelog_status");
    if (storedStatus) {
      setSelectedStatus(storedStatus);

      const storedDateFrom = window.localStorage.getItem("issuelog_datefrom");
      if (storedDateFrom) {
        setDateFrom(storedDateFrom);
      }
      const storedDateTo = window.localStorage.getItem("issuelog_dateto");
      if (storedDateTo) {
        setDateTo(storedDateTo);
      }
    }
  }, [pageNumSaleReport, sortSaleReport, dateFrom, dateTo, selectedStatus]);

  const handleChangePageSaleReport = (e, ispage) => {
    setPageNumSaleReport(ispage);
    // getData();
  };

  // STATEMENT ACCOUNT

  const [chooseMonth, setChooseMonth] = React.useState("");

  const handleChooseMonth = (e) => {
    setChooseMonth(e.target.value);
  };

  const [chooseYear, setChooseYear] = React.useState("");

  const handleChooseYear = (e) => {
    setChooseYear(e.target.value);
  };

  const handleSubmit = () => {
    if (chooseMonth == "") {
      alert("Please Choose a Month");
      return;
    }

    if (chooseYear == "") {
      alert("Please Choose a Year");
      return;
    }
    get_statement({
      token: get_user().token,
      month: chooseMonth,
      year: chooseYear,
    }).then((json) => {
      if (json.status) {
        window.open(json.data);
      } else {
        alert(json.message);
      }
    });
  };

  const handleChangeNxtPage = (val) => {
    setPage(val);
    window.localStorage.setItem("page", val);
  };

  React.useEffect(() => {
    const storedPage = window.localStorage.getItem("page");
    if (storedPage) {
      setPage(storedPage);
    } else {
      window.localStorage.setItem("page", "User Information");
      // setPage("User Information");
    }
  }, []);

  return (
    <React.Fragment>
      {loading ? (
        <div style={{ margin: "auto" }}>
          <Loader type="bubble-loop" bgColor="#1A5386" size={50} />
        </div>
      ) : (
        <React.Fragment>
          {customerDetail != null && (
            <Navbar2
              children={
                <Section pd="2rem">
                  <div>
                    <div
                      onClick={() => navigate(-1)}
                      style={{
                        cursor: "pointer",
                      }}
                    >
                      <Paragraph
                        color="#1A5386"
                        bold="400"
                        size="12px"
                        margin="0 0 1rem"
                      >
                        &lt; Back
                      </Paragraph>
                    </div>
                    <div className={classes.theFlexHeader}>
                      <Paragraph color="#1A5386" bold="600" size="24px">
                        Customer Detail
                      </Paragraph>

                      {/* <div className={classes.theFlexBtn} style={{ marginBottom: "0" }}>
                            <a
                                className={classes.theCustomActionBtn}
                            // onClick={() => handleOpenStockMove()}
                            >
                                <AddCircle sx={{ color: "#1A5386" }} />
                                <Paragraph margin="0 0 0 .4rem">Create New Order</Paragraph>
                            </a>
                            <a
                                className={classes.theCustomActionBtn_}
                            // onClick={() => handleOpenStockMove()}
                            >
                                <ExitToApp sx={{ color: "#1A5386" }} />
                                <Paragraph margin="0 0 0 .4rem">Export</Paragraph>
                            </a>
                        </div> */}
                    </div>
                    <div
                      style={{
                        borderBottom: "2px solid #707070",
                        padding: ".2rem 0",
                      }}
                    />
                    <br />

                    <div className={classes.theFlexAction}>
                      <div
                        className={
                          window.localStorage.getItem("page") ===
                          "User Information"
                            ? classes.theCustomActionBtnFill_
                            : classes.theCustomActionBtnInFill_
                        }
                        onClick={() => handleChangeNxtPage("User Information")}
                      >
                        <Paragraph>Customer Information</Paragraph>
                      </div>
                      <div
                        className={
                          window.localStorage.getItem("page") === "Address"
                            ? classes.theCustomActionBtnFill_
                            : classes.theCustomActionBtnInFill_
                        }
                        onClick={() => handleChangeNxtPage("Address")}
                      >
                        <Paragraph>Address</Paragraph>
                      </div>
                      <div
                        className={
                          window.localStorage.getItem("page") ===
                          "Order History"
                            ? classes.theCustomActionBtnFill_
                            : classes.theCustomActionBtnInFill_
                        }
                        onClick={() => handleChangeNxtPage("Order History")}
                      >
                        <Paragraph>Order History</Paragraph>
                      </div>
                      <div
                        className={
                          window.localStorage.getItem("page") ===
                          "Top Up History"
                            ? classes.theCustomActionBtnFill_
                            : classes.theCustomActionBtnInFill_
                        }
                        onClick={() => handleChangeNxtPage("Top Up History")}
                      >
                        <Paragraph>Top Up History</Paragraph>
                      </div>
                      <div
                        className={
                          window.localStorage.getItem("page") === "Invoice"
                            ? classes.theCustomActionBtnFill_
                            : classes.theCustomActionBtnInFill_
                        }
                        onClick={() => handleChangeNxtPage("Invoice")}
                      >
                        <Paragraph>Invoice</Paragraph>
                      </div>
                      <div
                        className={
                          window.localStorage.getItem("page") === "Credit Note"
                            ? classes.theCustomActionBtnFill_
                            : classes.theCustomActionBtnInFill_
                        }
                        onClick={() => handleChangeNxtPage("Credit Note")}
                      >
                        <Paragraph>Credit Note</Paragraph>
                      </div>
                      <div
                        className={
                          window.localStorage.getItem("page") === "Sale Report"
                            ? classes.theCustomActionBtnFill_
                            : classes.theCustomActionBtnInFill_
                        }
                        onClick={() => handleChangeNxtPage("Sale Report")}
                      >
                        <Paragraph>Sale Report</Paragraph>
                      </div>
                      <div
                        className={
                          window.localStorage.getItem("page") ===
                          "Statement Account"
                            ? classes.theCustomActionBtnFill_
                            : classes.theCustomActionBtnInFill_
                        }
                        onClick={() => handleChangeNxtPage("Statement Account")}
                      >
                        <Paragraph>Statement Account</Paragraph>
                      </div>
                      {/* <div
                            className={window.localStorage.getItem("page") === "Wallet" ? classes.theCustomActionBtnFill_ : classes.theCustomActionBtnInFill_}
                            onClick={() => setPage("Wallet")}
                        >
                            <Paragraph>Wallet</Paragraph>
                        </div> */}
                    </div>
                    <br />
                    {window.localStorage.getItem("page") ===
                      "User Information" && (
                      <React.Fragment>
                        <Card className={classes.theCard_}>
                          <div className={classes.theCHeader}>
                            <Paragraph
                              color="#000"
                              bold="600"
                              size="16px"
                              // margin="0 0 1rem"
                            >
                              General Information
                            </Paragraph>
                          </div>
                          <div className={classes.theCBody}>
                            <Grid container spacing={3}>
                              <Grid item xs={12} sm={12} md={6}>
                                <Grid container spacing={3}>
                                  <Grid item xs={12} sm={4} md={3}>
                                    <Paragraph size="14px">Name:</Paragraph>
                                  </Grid>
                                  <Grid item xs={12} sm={8} md={9}>
                                    <Paragraph size="14px" bold="600">
                                      {customerDetail.entityid}
                                    </Paragraph>
                                  </Grid>
                                  <Grid item xs={12} sm={4} md={3}>
                                    <Paragraph size="14px">
                                      Contact Number:
                                    </Paragraph>
                                  </Grid>
                                  <Grid item xs={12} sm={8} md={9}>
                                    <Paragraph size="14px" bold="600">
                                      {customerDetail.phone != "" &&
                                      customerDetail.phone != null
                                        ? customerDetail.phone
                                        : "-"}
                                    </Paragraph>
                                  </Grid>
                                  <Grid item xs={12} sm={4} md={3}>
                                    <Paragraph size="14px">Email:</Paragraph>
                                  </Grid>
                                  <Grid item xs={12} sm={8} md={9}>
                                    <Paragraph size="14px" bold="600">
                                      {customerDetail.email != "" &&
                                      customerDetail.email != null
                                        ? customerDetail.email
                                        : "-"}
                                    </Paragraph>
                                  </Grid>
                                  <Grid item xs={12} sm={4} md={3}>
                                    <Paragraph size="14px">Category:</Paragraph>
                                  </Grid>
                                  <Grid item xs={12} sm={8} md={9}>
                                    <Paragraph size="14px" bold="600">
                                      {customerDetail.category != "" &&
                                      customerDetail.category != null
                                        ? customerDetail.category
                                        : "-"}
                                    </Paragraph>
                                  </Grid>
                                  <Grid item xs={12} sm={4} md={3}>
                                    <Paragraph size="14px">Inactive:</Paragraph>
                                  </Grid>
                                  <Grid item xs={12} sm={8} md={9}>
                                    <Paragraph size="14px" bold="600">
                                      {customerDetail.inactive == "F"
                                        ? "No"
                                        : "Yes"}
                                    </Paragraph>
                                  </Grid>
                                  <Grid item xs={12} sm={4} md={3}>
                                    <Paragraph size="14px">
                                      Payment Type:
                                    </Paragraph>
                                  </Grid>
                                  <Grid item xs={12} sm={8} md={9}>
                                    <Paragraph size="14px" bold="600">
                                      {customerDetail.paymenttype != "" &&
                                      customerDetail.paymenttype != null
                                        ? customerDetail.paymenttype
                                        : "-"}
                                    </Paragraph>
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Grid item xs={12} sm={12} md={6}>
                                <Grid container spacing={3}>
                                  <Grid item xs={12} sm={4} md={3}>
                                    <Paragraph size="14px">Terms:</Paragraph>
                                  </Grid>
                                  <Grid item xs={12} sm={8} md={9}>
                                    <Paragraph size="14px" bold="600">
                                      {customerDetail.terms != "" &&
                                      customerDetail.terms != null
                                        ? customerDetail.terms
                                        : "-"}
                                    </Paragraph>
                                  </Grid>
                                  <Grid item xs={12} sm={4} md={3}>
                                    <Paragraph size="14px">Currency:</Paragraph>
                                  </Grid>
                                  <Grid item xs={12} sm={8} md={9}>
                                    <Paragraph size="14px" bold="600">
                                      {customerDetail.currency != "" &&
                                      customerDetail.currency != null
                                        ? customerDetail.currency
                                        : "-"}
                                    </Paragraph>
                                  </Grid>
                                  {customerDetail.paymenttype != "Cash" && (
                                    <React.Fragment>
                                      <Grid item xs={12} sm={4} md={3}>
                                        <Paragraph size="14px">
                                          {customerDetail.paymenttype ==
                                          "Prepaid"
                                            ? "Deposit Balance"
                                            : "Balance"}
                                        </Paragraph>
                                      </Grid>
                                      <Grid item xs={12} sm={8} md={9}>
                                        <Paragraph size="14px" bold="600">
                                          {customerDetail.paymenttype ==
                                          "Prepaid"
                                            ? customerDetail.current_depositbalance
                                            : customerDetail.current_balance}
                                        </Paragraph>
                                      </Grid>
                                    </React.Fragment>
                                  )}
                                  <Grid item xs={12} sm={4} md={3}>
                                    <Paragraph size="14px">
                                      Price Level:
                                    </Paragraph>
                                  </Grid>
                                  <Grid item xs={12} sm={8} md={9}>
                                    <Paragraph size="14px" bold="600">
                                      {customerDetail.pricelevel}
                                    </Paragraph>
                                  </Grid>
                                  <Grid item xs={12} sm={4} md={3}>
                                    <Paragraph size="14px">
                                      Days Overdue:
                                    </Paragraph>
                                  </Grid>
                                  <Grid item xs={12} sm={8} md={9}>
                                    <Paragraph
                                      size="14px"
                                      color={
                                        customerDetail.daysoverdue > 0
                                          ? "#C52626"
                                          : "#000"
                                      }
                                      bold="600"
                                    >
                                      {customerDetail.daysoverdue}
                                    </Paragraph>
                                  </Grid>
                                  <Grid item xs={12} sm={4} md={3}>
                                    <Paragraph size="14px">
                                      Sales Rep:
                                    </Paragraph>
                                  </Grid>
                                  <Grid item xs={12} sm={8} md={9}>
                                    <Paragraph size="14px" bold="600">
                                      {customerDetail.salesrep_name}
                                    </Paragraph>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          </div>
                        </Card>
                        <br />

                        <Card className={classes.theCard_}>
                          <div className={classes.theCHeader}>
                            <Paragraph
                              color="#000"
                              bold="600"
                              size="16px"
                              // margin="0 0 1rem"
                            >
                              Access List
                            </Paragraph>
                          </div>
                          <div className={classes.theCBody}>
                            <Grid container spacing={3}>
                              {/* <Grid item xs={12} sm={12} md={6}>
                                                <Paragraph size="14px" margin="0 0 0.5rem">Billing Address:</Paragraph>
                                                <Paragraph size="14px" bold="600">Lestk Sdn Bhd</Paragraph>
                                            </Grid> */}
                              <Grid item xs={12} sm={12} md={12}>
                                <TableContainer>
                                  <Table>
                                    <TableHead
                                      style={{ backgroundColor: "#1A5386" }}
                                    >
                                      <TableRow>
                                        <TableCell
                                          style={{
                                            borderRadius: "10px 0 0 10px",
                                          }}
                                          className={classes.theHeadTitle}
                                        >
                                          Contact Name
                                        </TableCell>
                                        <TableCell
                                          className={classes.theHeadTitle}
                                        >
                                          Name
                                        </TableCell>
                                        <TableCell
                                          className={classes.theHeadTitle}
                                        >
                                          Contact Number
                                        </TableCell>
                                        <TableCell
                                          className={classes.theHeadTitle}
                                        >
                                          Email
                                        </TableCell>
                                        <TableCell
                                          className={classes.theHeadTitle}
                                        >
                                          Dropship
                                        </TableCell>
                                        <TableCell
                                          style={{
                                            borderRadius: "0 10px 10px 0",
                                          }}
                                          className={classes.theHeadTitle}
                                        >
                                          Give Access
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {customerDetail.hasOwnProperty(
                                        "contact"
                                      ) &&
                                        customerDetail.contact.map(
                                          (item, index) => {
                                            // if (searchKey != "") {
                                            //     if ((item.entityid).toUpperCase().indexOf(searchKey.toUpperCase()) <= -1) {
                                            //         return
                                            //     }
                                            // }
                                            return (
                                              <TableRow>
                                                <TableCell>
                                                  {item.contactname}
                                                </TableCell>
                                                <TableCell>
                                                  {item.name}
                                                </TableCell>
                                                <TableCell>
                                                  {item.phone}
                                                </TableCell>
                                                <TableCell>
                                                  {item.email}
                                                </TableCell>
                                                <TableCell>
                                                  {item.dropship == 1
                                                    ? "Yes"
                                                    : "No"}
                                                </TableCell>
                                                <TableCell>
                                                  {item.giveaccess == 1
                                                    ? "Yes"
                                                    : "No"}
                                                </TableCell>
                                              </TableRow>
                                            );
                                          }
                                        )}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              </Grid>
                            </Grid>
                          </div>
                        </Card>
                        <br />

                        <Card className={classes.theCard_}>
                          <div className={classes.theCHeader}>
                            <Paragraph
                              color="#000"
                              bold="600"
                              size="16px"
                              // margin="0 0 1rem"
                            >
                              Billing & Shipping Address
                            </Paragraph>
                          </div>
                          <div className={classes.theCBody}>
                            <Grid container spacing={3}>
                              {/* <Grid item xs={12} sm={12} md={6}>
                                    <Paragraph size="14px" margin="0 0 0.5rem">Billing Address:</Paragraph>
                                    <Paragraph size="14px" bold="600">Lestk Sdn Bhd</Paragraph>
                                </Grid> */}
                              <Grid item xs={12} sm={12} md={6}>
                                <Paragraph size="14px" margin="0 0 0.5rem">
                                  Address:
                                </Paragraph>
                                {customerDetail.address.length == 0 ? (
                                  <Paragraph
                                    size="14px"
                                    bold="600"
                                    margin="0 0 0.5rem"
                                  >
                                    No address yet
                                  </Paragraph>
                                ) : (
                                  customerDetail.address.map((res) => (
                                    <Paragraph
                                      size="14px"
                                      bold="600"
                                      margin="0 0 0.5rem"
                                    >
                                      {res.addr1},
                                      <br />
                                      {res.addr2},
                                      <br />
                                      {res.city} {res.zip} {res.state}{" "}
                                      {res.country}.
                                    </Paragraph>
                                  ))
                                )}
                                {/* <Paragraph size="14px" bold="600" margin="0 0 0.5rem">Lestk Sdn Bhd</Paragraph>
                                                <Paragraph size="14px" bold="600" margin="0 0 0.5rem">Lestk Sdn Bhd</Paragraph> */}
                              </Grid>
                            </Grid>
                          </div>
                        </Card>
                      </React.Fragment>
                    )}
                    {window.localStorage.getItem("page") === "Address" && (
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} md={12}>
                          <Card className={classes.theCard}>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                            >
                              <a
                                style={{ margin: "0 0 0 auto" }}
                                className={classes.theCustomActionBtn_}
                                onClick={() => handleOpenAdd()}
                              >
                                <AddCircle sx={{ color: "#1A5386" }} />
                                <Paragraph margin="0 0 0 .4rem">
                                  Create New Address
                                </Paragraph>
                              </a>
                            </div>
                            <br />
                            <TableContainer>
                              <Table>
                                <TableHead
                                  style={{ backgroundColor: "#1A5386" }}
                                >
                                  <TableRow>
                                    <TableCell
                                      style={{ borderRadius: "10px 0 0 10px" }}
                                      className={classes.theHeadTitle}
                                    >
                                      Contact Name
                                    </TableCell>
                                    <TableCell className={classes.theHeadTitle}>
                                      Contact Number
                                    </TableCell>
                                    <TableCell className={classes.theHeadTitle}>
                                      Address 1
                                    </TableCell>
                                    <TableCell className={classes.theHeadTitle}>
                                      Address 2
                                    </TableCell>
                                    <TableCell className={classes.theHeadTitle}>
                                      City
                                    </TableCell>
                                    <TableCell className={classes.theHeadTitle}>
                                      Zip
                                    </TableCell>
                                    <TableCell className={classes.theHeadTitle}>
                                      State
                                    </TableCell>
                                    <TableCell className={classes.theHeadTitle}>
                                      Country
                                    </TableCell>
                                    {get_user().role_id == 1 && (
                                      <TableCell
                                        style={{
                                          borderRadius: "0 10px 10px 0",
                                        }}
                                        className={classes.theHeadTitle}
                                      ></TableCell>
                                    )}
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {customerDetail != null &&
                                    customerDetail.address.map(
                                      (item, index) => (
                                        <TableRow>
                                          <TableCell
                                            style={{
                                              background:
                                                index % 2 == 0
                                                  ? "#f2f2f2"
                                                  : "#fff",
                                            }}
                                          >
                                            {item.contact_name}
                                          </TableCell>
                                          <TableCell
                                            style={{
                                              background:
                                                index % 2 == 0
                                                  ? "#f2f2f2"
                                                  : "#fff",
                                            }}
                                          >
                                            {item.contact_number}
                                          </TableCell>
                                          <TableCell
                                            style={{
                                              background:
                                                index % 2 == 0
                                                  ? "#f2f2f2"
                                                  : "#fff",
                                            }}
                                          >
                                            {item.addr1}
                                          </TableCell>
                                          <TableCell
                                            style={{
                                              background:
                                                index % 2 == 0
                                                  ? "#f2f2f2"
                                                  : "#fff",
                                            }}
                                          >
                                            {item.addr2}
                                          </TableCell>
                                          <TableCell
                                            style={{
                                              background:
                                                index % 2 == 0
                                                  ? "#f2f2f2"
                                                  : "#fff",
                                            }}
                                          >
                                            {item.city}
                                          </TableCell>
                                          <TableCell
                                            style={{
                                              background:
                                                index % 2 == 0
                                                  ? "#f2f2f2"
                                                  : "#fff",
                                            }}
                                          >
                                            {item.zip}
                                          </TableCell>
                                          <TableCell
                                            style={{
                                              background:
                                                index % 2 == 0
                                                  ? "#f2f2f2"
                                                  : "#fff",
                                            }}
                                          >
                                            {item.state}
                                          </TableCell>
                                          <TableCell
                                            style={{
                                              background:
                                                index % 2 == 0
                                                  ? "#f2f2f2"
                                                  : "#fff",
                                            }}
                                          >
                                            {item.country}
                                          </TableCell>
                                          {get_user().role_id == 1 && (
                                            <TableCell
                                              style={{
                                                background:
                                                  index % 2 == 0
                                                    ? "#f2f2f2"
                                                    : "#fff",
                                              }}
                                            >
                                              {/* {item.addr1} */}
                                              <Button
                                                onClick={() => handleOpen(item)}
                                                label="Edit"
                                                color="#fff"
                                                bg="#1A5386"
                                                size="12px"
                                                pd="10px"
                                                br="5px"
                                                style={{ marginBottom: "10px" }}
                                              />
                                              <Button
                                                onClick={() =>
                                                  handleOpenDelete(
                                                    item.customer_address_id
                                                  )
                                                }
                                                label="Delete"
                                                color="#1A5386"
                                                bg="#fff"
                                                box="1px solid #1A5386"
                                                size="12px"
                                                pd="10px"
                                                br="5px"
                                              />
                                            </TableCell>
                                          )}
                                        </TableRow>
                                      )
                                    )}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Card>
                          <br />
                          <br />
                        </Grid>
                      </Grid>
                    )}
                    {window.localStorage.getItem("page") ===
                      "Order History" && (
                      <>
                        <FormInputNoLabel
                          placeholder="Search Customer"
                          border="1px solid #d7d7d7"
                          br="6px"
                          onChange={handleSearch}
                          value={searchKey}
                        />
                        <br />
                        <Grid container spacing={3}>
                          <Grid item xs={12} sm={12} md={12}>
                            <Card className={classes.theCard} style={{ position: "relative" }}>
                              <TableContainer style={{ position: "relative" }}>
                                {loadingOrdersHistory && (
                                  <div
                                    style={{
                                      position: "absolute",
                                      top: 0,
                                      left: 0,
                                      right: 0,
                                      bottom: 0,
                                      backgroundColor: "rgba(255, 255, 255, 0.7)",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      zIndex: 1000,
                                      pointerEvents: "auto",
                                    }}
                                  >
                                    <div
                                      style={{
                                        backgroundColor: "#fff",
                                        padding: "1rem",
                                        borderRadius: "8px",
                                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                      }}
                                    >
                                      <Loader
                                        type="snipper-default"
                                        bgColor={"#1A5386"}
                                        size={50}
                                      />
                                    </div>
                                  </div>
                                )}
                                <Table>
                                  <TableHead
                                    style={{ backgroundColor: "#1A5386" }}
                                  >
                                    <TableRow>
                                      <TableCell
                                        style={{
                                          borderRadius: "10px 0 0 10px",
                                        }}
                                        className={classes.theHeadTitle}
                                      >
                                        Date
                                      </TableCell>
                                      <TableCell
                                        className={classes.theHeadTitle}
                                      >
                                        Order Number
                                      </TableCell>
                                      <TableCell
                                        className={classes.theHeadTitle}
                                      >
                                        Customer Name
                                      </TableCell>
                                      <TableCell
                                        className={classes.theHeadTitle}
                                      >
                                        Total Items
                                      </TableCell>
                                      <TableCell
                                        className={classes.theHeadTitle}
                                      >
                                        Price Level
                                      </TableCell>
                                      <TableCell
                                        className={classes.theHeadTitle}
                                      >
                                        Amount
                                      </TableCell>
                                      <TableCell
                                        style={{
                                          borderRadius: "0 10px 10px 0",
                                        }}
                                        className={classes.theHeadTitle}
                                      >
                                        Status
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {customerHistory && customerHistory.length > 0 &&
                                      customerHistory.map((item, index) => {
                                        return (
                                          <TableRow>
                                            <a
                                              style={{ display: "contents" }}
                                              // href={`../saledetail/${item.sales_order_id}`}
                                            >
                                              {/* <TableCell><Checkbox
                                                  sx={{
                                                      color: "#1A5386",
                                                      '&.Mui-checked': {
                                                          color: "#1A5386",
                                                      },
                                                  }} /></TableCell> */}
                                              <TableCell
                                                onClick={() =>
                                                  navigate(
                                                    "/saledetail/" +
                                                      item.sales_order_id
                                                  )
                                                }
                                              >
                                                {item.date
                                                  ? moment(item.date).format(
                                                      "DD/MM/YYYY"
                                                    )
                                                  : item.created_date
                                                  ? moment(item.created_date).format(
                                                      "DD/MM/YYYY"
                                                    )
                                                  : "-"}
                                              </TableCell>
                                              <TableCell
                                                className={
                                                  classes.theUnderLineLabel
                                                }
                                                onClick={() =>
                                                  navigate(
                                                    "/saledetail/" +
                                                      item.sales_order_id
                                                  )
                                                }
                                              >
                                                {item.sales_order_id != "" &&
                                                item.sales_order_id != null
                                                  ? item.sales_order_id
                                                  : "-"}
                                              </TableCell>
                                              <TableCell
                                                onClick={() =>
                                                  navigate(
                                                    "/saledetail/" +
                                                      item.sales_order_id
                                                  )
                                                }
                                              >
                                                {item.customer_name}
                                              </TableCell>
                                              <TableCell
                                                onClick={() =>
                                                  navigate(
                                                    "/saledetail/" +
                                                      item.sales_order_id
                                                  )
                                                }
                                              >
                                                {item.item.length}
                                              </TableCell>
                                              <TableCell
                                                onClick={() =>
                                                  navigate(
                                                    "/saledetail/" +
                                                      item.sales_order_id
                                                  )
                                                }
                                              >
                                                {item.pricelevel}
                                              </TableCell>
                                              <TableCell
                                                onClick={() =>
                                                  navigate(
                                                    "/saledetail/" +
                                                      item.sales_order_id
                                                  )
                                                }
                                              >
                                                <div
                                                  style={{ color: "#1A5386" }}
                                                >
                                                  Final Amount:{" "}
                                                  {item.final_amount}
                                                </div>
                                                {item.deposit_amount !=
                                                  "0.00" && (
                                                  <React.Fragment>
                                                    <div
                                                      style={{
                                                        fontSize: "12px",
                                                        color: "#C52626",
                                                      }}
                                                    >
                                                      Deposit Amount:{" "}
                                                      {item.deposit_amount}
                                                    </div>
                                                    <div
                                                      style={{
                                                        fontSize: "12px",
                                                        color: "#C52626",
                                                      }}
                                                    >
                                                      Outstanding Amount:{" "}
                                                      {item.outstanding_amount}
                                                    </div>
                                                  </React.Fragment>
                                                )}
                                              </TableCell>
                                              <TableCell
                                                onClick={() =>
                                                  navigate(
                                                    "/saledetail/" +
                                                      item.sales_order_id
                                                  )
                                                }
                                              >
                                                {item.status}
                                              </TableCell>
                                              {/* <TableCell
                                                    onClick={() => navigate("/saledetail/" + item.customer_id)}
                                                >
                                                    RM{item.total_amount}
                                                </TableCell> */}
                                            </a>
                                          </TableRow>
                                        );
                                      })}
                                    {!loadingOrdersHistory && customerHistory && customerHistory.length === 0 && (
                                      <TableRow>
                                        <TableCell colSpan={7} style={{ textAlign: "center", padding: "2rem" }}>
                                          <Paragraph size="14px" color="#707070">
                                            No orders found
                                          </Paragraph>
                                        </TableCell>
                                      </TableRow>
                                    )}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                              <div
                                style={{
                                  borderTop: "1px solid #707070",
                                  borderBottom: "1px solid #707070",
                                  margin: "1rem 0 0",
                                  cursor: "pointer",
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  alignItems: "flex-end",
                                }}
                              >
                                <TablePagination
                                  // variant="outlined"
                                  color="primary"
                                  page={ordersHistoryPageNum}
                                  onPageChange={handleChangeOrdersHistoryPage}
                                  count={ordersHistoryTotal}
                                  // defaultPage={pageList}
                                  rowsPerPage={50}
                                  rowsPerPageOptions={[50]}
                                  // count={10}
                                />
                              </div>

                              {/* <div style={{
                                  borderTop: "1px solid #707070",
                                  borderBottom: "1px solid #707070",
                                  margin: "1rem 0 0",
                                  cursor: "pointer",
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  alignItems: "flex-end",
                              }}>
                                  <TablePagination
                                      // variant="outlined"
                                      color="primary"
                                      page={pageNum}
                                      onPageChange={handleChangePage}
                                      count={totalList}
                                      // defaultPage={pageList}
                                      rowsPerPage={10}
                                      rowsPerPageOptions={[10]}
                                  // count={10}
                                  />
                              </div> */}
                            </Card>
                            <br />
                            <br />
                          </Grid>
                        </Grid>
                      </>
                    )}
                    {window.localStorage.getItem("page") ===
                      "Top Up History" && (
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} md={12}>
                          <Card className={classes.theCard}>
                            <TableContainer>
                              <Table>
                                <TableHead
                                  style={{ backgroundColor: "#1A5386" }}
                                >
                                  <TableRow>
                                    <TableCell
                                      style={{ borderRadius: "10px 0 0 10px" }}
                                      className={classes.theHeadTitle}
                                    >
                                      Date
                                    </TableCell>
                                    <TableCell className={classes.theHeadTitle}>
                                      Order Number
                                    </TableCell>
                                    {/* <TableCell className={classes.theHeadTitle}>
                                                                            Order Number
                                                                        </TableCell> */}
                                    <TableCell className={classes.theHeadTitle}>
                                      Razer ID
                                    </TableCell>
                                    <TableCell className={classes.theHeadTitle}>
                                      Top Up ID
                                    </TableCell>
                                    <TableCell className={classes.theHeadTitle}>
                                      Currency
                                    </TableCell>
                                    <TableCell className={classes.theHeadTitle}>
                                      Amount
                                    </TableCell>
                                    <TableCell
                                      style={{ borderRadius: "0 10px 10px 0" }}
                                      className={classes.theHeadTitle}
                                    >
                                      Status
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {topupHistory != null &&
                                    topupHistory.map((item, index) => {
                                      // if (searchKey != "") {
                                      //     if ((item.entityid).toUpperCase().indexOf(searchKey.toUpperCase()) <= -1) {
                                      //         return
                                      //     }
                                      // }
                                      return (
                                        <TableRow>
                                          <a
                                            style={{ display: "contents" }}
                                            // href={`../saledetail/${item.sales_order_id}`}
                                          >
                                            {/* <TableCell><Checkbox
                                                sx={{
                                                    color: "#1A5386",
                                                    '&.Mui-checked': {
                                                        color: "#1A5386",
                                                    },
                                                }} /></TableCell> */}
                                            <TableCell
                                            // onClick={() => navigate("/saledetail/" + item.sales_order_id)}
                                            >
                                              {item.date
                                                ? moment(item.date).format(
                                                    "DD/MM/YYYY"
                                                  )
                                                : item.created_date
                                                ? moment(item.created_date).format(
                                                    "DD/MM/YYYY"
                                                  )
                                                : "-"}
                                            </TableCell>
                                            <TableCell
                                              className={
                                                classes.theUnderLineLabel
                                              }
                                              // onClick={() => navigate("/saledetail/" + item.sales_order_id)}
                                            >
                                              {item.sales_order_id != "" &&
                                              item.sales_order_id != null
                                                ? item.sales_order_id
                                                : "-"}
                                            </TableCell>
                                            <TableCell
                                            // onClick={() => navigate("/saledetail/" + item.sales_order_id)}
                                            >
                                              {item.razerid}
                                            </TableCell>
                                            <TableCell
                                            // onClick={() => navigate("/saledetail/" + item.sales_order_id)}
                                            >
                                              {item.topup_id}
                                            </TableCell>
                                            <TableCell
                                            // onClick={() => navigate("/saledetail/" + item.sales_order_id)}
                                            >
                                              {item.currency}
                                            </TableCell>
                                            <TableCell
                                            // onClick={() => navigate("/saledetail/" + item.sales_order_id)}
                                            >
                                              {item.amount}
                                            </TableCell>
                                            <TableCell
                                            // onClick={() => navigate("/saledetail/" + item.sales_order_id)}
                                            >
                                              {item.status}
                                            </TableCell>
                                          </a>
                                        </TableRow>
                                      );
                                    })}
                                </TableBody>
                              </Table>
                            </TableContainer>

                            {/* <div style={{
                                borderTop: "1px solid #707070",
                                borderBottom: "1px solid #707070",
                                margin: "1rem 0 0",
                                cursor: "pointer",
                                display: "flex",
                                justifyContent: "flex-end",
                                alignItems: "flex-end",
                            }}>
                                <TablePagination
                                    // variant="outlined"
                                    color="primary"
                                    page={pageNum}
                                    onPageChange={handleChangePage}
                                    count={totalList}
                                    // defaultPage={pageList}
                                    rowsPerPage={10}
                                    rowsPerPageOptions={[10]}
                                // count={10}
                                />
                            </div> */}
                          </Card>
                          <br />
                          <br />
                        </Grid>
                      </Grid>
                    )}
                    {window.localStorage.getItem("page") === "Invoice" && (
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} md={12}>
                          <Card className={classes.theCard}>
                            <TableContainer>
                              <Table>
                                <TableHead
                                  style={{ backgroundColor: "#1A5386" }}
                                >
                                  <TableRow>
                                    <TableCell
                                      style={{ borderRadius: "10px 0 0 10px" }}
                                      className={classes.theHeadTitle}
                                    >
                                      Date
                                    </TableCell>
                                    <TableCell className={classes.theHeadTitle}>
                                      Order Number
                                    </TableCell>
                                    <TableCell className={classes.theHeadTitle}>
                                      Invoice
                                    </TableCell>
                                    {/* <TableCell className={classes.theHeadTitle}>
                                                                            Total Items
                                                                        </TableCell> */}
                                    <TableCell className={classes.theHeadTitle}>
                                      Price Level
                                    </TableCell>
                                    <TableCell className={classes.theHeadTitle}>
                                      Amount
                                    </TableCell>
                                    <TableCell
                                      style={{ borderRadius: "0 10px 10px 0" }}
                                      className={classes.theHeadTitle}
                                    >
                                      Status
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {invoiceList != null &&
                                    invoiceList
                                      .slice(pageNum * 10, pageNum * 10 + 10)
                                      .map((item, index) => {
                                        // if (searchKey != "") {
                                        //     if ((item.entityid).toUpperCase().indexOf(searchKey.toUpperCase()) <= -1) {
                                        //         return
                                        //     }
                                        // }
                                        return (
                                          <TableRow>
                                            <a
                                              style={{ display: "contents" }}
                                              // href={`../saledetail/${item.sales_order_id}`}
                                            >
                                              {/* <TableCell><Checkbox
                                              sx={{
                                                  color: "#1A5386",
                                                  '&.Mui-checked': {
                                                      color: "#1A5386",
                                                  },
                                              }} /></TableCell> */}
                                              <TableCell
                                                onClick={() =>
                                                  navigate(
                                                    "/saledetail/" +
                                                      item.sales_order_id
                                                  )
                                                }
                                              >
                                                {item.date
                                                  ? moment(item.date).format(
                                                      "DD/MM/YYYY"
                                                    )
                                                  : item.created_date
                                                  ? moment(item.created_date).format(
                                                      "DD/MM/YYYY"
                                                    )
                                                  : "-"}
                                              </TableCell>
                                              <TableCell
                                                className={
                                                  classes.theUnderLineLabel
                                                }
                                                onClick={() =>
                                                  navigate(
                                                    "/saledetail/" +
                                                      item.sales_order_id
                                                  )
                                                }
                                              >
                                                {item.sales_order_id != "" &&
                                                item.sales_order_id != null
                                                  ? item.sales_order_id
                                                  : "-"}
                                              </TableCell>
                                              <TableCell
                                              // onClick={() => navigate("/saledetail/" + item.sales_order_id)}
                                              >
                                                <a
                                                  href={item.file}
                                                  target="_blank"
                                                >
                                                  View Invoice
                                                </a>
                                              </TableCell>
                                              <TableCell
                                                onClick={() =>
                                                  navigate(
                                                    "/saledetail/" +
                                                      item.sales_order_id
                                                  )
                                                }
                                              >
                                                {item.pricelevel}
                                              </TableCell>
                                              <TableCell
                                                onClick={() =>
                                                  navigate(
                                                    "/saledetail/" +
                                                      item.sales_order_id
                                                  )
                                                }
                                              >
                                                <div
                                                  style={{ color: "#1A5386" }}
                                                >
                                                  Final Amount:{" "}
                                                  {item.final_amount}
                                                </div>
                                                {item.deposit_amount !=
                                                  "0.00" && (
                                                  <React.Fragment>
                                                    <div
                                                      style={{
                                                        fontSize: "12px",
                                                        color: "#C52626",
                                                      }}
                                                    >
                                                      Deposit Amount:{" "}
                                                      {item.deposit_amount}
                                                    </div>
                                                    <div
                                                      style={{
                                                        fontSize: "12px",
                                                        color: "#C52626",
                                                      }}
                                                    >
                                                      Outstanding Amount:{" "}
                                                      {item.outstanding_amount}
                                                    </div>
                                                  </React.Fragment>
                                                )}
                                              </TableCell>
                                              <TableCell
                                                onClick={() =>
                                                  navigate(
                                                    "/saledetail/" +
                                                      item.sales_order_id
                                                  )
                                                }
                                              >
                                                {item.status}
                                              </TableCell>
                                              {/* <TableCell
                                                onClick={() => navigate("/saledetail/" + item.customer_id)}
                                            >
                                                RM{item.total_amount}
                                            </TableCell> */}
                                            </a>
                                          </TableRow>
                                        );
                                      })}
                                </TableBody>
                              </Table>
                            </TableContainer>

                            <div
                              style={{
                                borderTop: "1px solid #707070",
                                borderBottom: "1px solid #707070",
                                margin: "1rem 0 0",
                                cursor: "pointer",
                                display: "flex",
                                justifyContent: "flex-end",
                                alignItems: "flex-end",
                              }}
                            >
                              <TablePagination
                                // variant="outlined"
                                color="primary"
                                page={pageNum}
                                onPageChange={handleChangePage}
                                count={totalList}
                                // defaultPage={pageList}
                                rowsPerPage={10}
                                rowsPerPageOptions={[10]}
                                // count={10}
                              />
                            </div>
                          </Card>
                          <br />
                          <br />
                        </Grid>
                      </Grid>
                    )}
                    {window.localStorage.getItem("page") === "Credit Note" && (
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} md={12}>
                          <Card className={classes.theCard}>
                            <TableContainer>
                              <Table>
                                <TableHead
                                  style={{ backgroundColor: "#1A5386" }}
                                >
                                  <TableRow>
                                    <TableCell
                                      style={{ borderRadius: "10px 0 0 10px" }}
                                      className={classes.theHeadTitle}
                                    >
                                      Date
                                    </TableCell>
                                    <TableCell className={classes.theHeadTitle}>
                                      SO
                                    </TableCell>
                                    <TableCell className={classes.theHeadTitle}>
                                      Amount
                                    </TableCell>
                                    <TableCell
                                      // style={{ borderRadius: "0 10px 10px 0" }}
                                      className={classes.theHeadTitle}
                                    >
                                      Status
                                    </TableCell>
                                    <TableCell
                                      style={{ borderRadius: "0 10px 10px 0" }}
                                      className={classes.theHeadTitle}
                                    >
                                      Credit Memo
                                    </TableCell>
                                    {/* <TableCell className={classes.theHeadTitle}>
                                                                            RMA Link
                                                                        </TableCell> */}
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {customerNoteList != null &&
                                    customerNoteList.map((item, index) => {
                                      // if (searchKey != "") {
                                      //     if ((item.entityid).toUpperCase().indexOf(searchKey.toUpperCase()) <= -1) {
                                      //         return
                                      //     }
                                      // }
                                      return (
                                        <TableRow>
                                          <a
                                            style={{ display: "contents" }}
                                            // href={`../saledetail/${item.sales_order_id}`}
                                          >
                                            <TableCell
                                              onClick={() =>
                                                navigate(
                                                  "/saledetail/" +
                                                    item.sales_order_id
                                                )
                                              }
                                            >
                                              {item.date}
                                            </TableCell>
                                            <TableCell
                                              onClick={() =>
                                                navigate(
                                                  "/saledetail/" +
                                                    item.sales_order_id
                                                )
                                              }
                                            >
                                              {item.ecommso}
                                            </TableCell>

                                            <TableCell
                                              onClick={() =>
                                                navigate(
                                                  "/saledetail/" +
                                                    item.sales_order_id
                                                )
                                              }
                                            >
                                              {item.amount}
                                            </TableCell>
                                            <TableCell
                                              onClick={() =>
                                                navigate(
                                                  "/saledetail/" +
                                                    item.sales_order_id
                                                )
                                              }
                                            >
                                              {item.status}
                                            </TableCell>
                                            <TableCell
                                            // onClick={() => navigate("/saledetail/" + item.sales_order_id)}
                                            >
                                              <a
                                                href={item.cmlink}
                                                target="_blank"
                                              >
                                                View link
                                              </a>
                                            </TableCell>
                                          </a>
                                        </TableRow>
                                      );
                                    })}
                                </TableBody>
                              </Table>
                            </TableContainer>

                            {/* <div style={{
                                  borderTop: "1px solid #707070",
                                  borderBottom: "1px solid #707070",
                                  margin: "1rem 0 0",
                                  cursor: "pointer",
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  alignItems: "flex-end",
                              }}>
                                  <TablePagination
                                      // variant="outlined"
                                      color="primary"
                                      page={pageNum}
                                      onPageChange={handleChangePage}
                                      count={totalList}
                                      // defaultPage={pageList}
                                      rowsPerPage={10}
                                      rowsPerPageOptions={[10]}
                                  // count={10}
                                  />
                              </div> */}
                          </Card>
                          <br />
                          <br />
                        </Grid>
                      </Grid>
                    )}
                    {window.localStorage.getItem("page") === "Sale Report" && (
                      <>
                        <div>
                          <div className={classes.theFlexHeader}>
                            <div
                              className={classes.theFlexBtn}
                              style={{ marginBottom: "0" }}
                            ></div>
                          </div>

                          <div className={classes.theFlexAction}>
                            <div
                              className={classes.theWx}
                              style={{ margin: "0 20px 0 0" }}
                            >
                              <FormInputNoLabel
                                placeholder="Search"
                                border="1px solid #d7d7d7"
                                br="6px"
                                onChange={handleSearchSaleReport}
                                value={searchKey}
                              />
                            </div>
                            <div
                              className={classes.theWx}
                              style={{ margin: "0 20px 0 0" }}
                            >
                              {/* <FormInputSelect>
                                <Select
                                  displayEmpty
                                  inputProps={{
                                    "aria-label": "Without label",
                                  }}
                                  value={selectedStatus}
                                  onChange={handleChooseStatus}
                                >
                                  {returnStatus != null &&
                                    returnStatus.map((res) => (
                                      <MenuItem value={res.status}>
                                        {res.status}
                                      </MenuItem>
                                    ))}
                                </Select>
                              </FormInputSelect> */}
                            </div>
                            <div
                              className={classes.theWx}
                              style={{ margin: "0 20px 0 0" }}
                            >
                              <FormInputNoLabel
                                placeholder="Search"
                                border="1px solid #d7d7d7"
                                br="6px"
                                onChange={handleChangeDateFrom}
                                value={dateFrom}
                                type="date"
                              />
                            </div>

                            <Paragraph bold="bold" color="#707070">
                              to
                            </Paragraph>
                            <div
                              className={classes.theWx}
                              style={{ margin: "0 20px 0 20px" }}
                            >
                              <FormInputNoLabel
                                placeholder="Search"
                                border="1px solid #d7d7d7"
                                br="6px"
                                onChange={handleChangeDateTo}
                                value={dateTo}
                                type="date"
                              />
                            </div>
                          </div>

                          <Grid container spacing={3}>
                            <Grid item xs={12} sm={12} md={12}>
                              <Card className={classes.theCard}>
                                <TableContainer>
                                  <Table>
                                    <TableHead
                                      style={{ backgroundColor: "#1A5386" }}
                                    >
                                      {/* <TableRow>
                                        <TableCell
                                          style={{
                                            borderRadius: "10px 0 0 10px",
                                          }}
                                          className={classes.theHeadTitle}
                                        >
                                          Return Order ID
                                        </TableCell>
                                        <TableCell
                                          className={classes.theHeadTitle}
                                        >
                                          SO Number
                                        </TableCell>

                                        <TableCell
                                          className={classes.theHeadTitle}
                                        >
                                          Customer
                                        </TableCell>
                                        <TableCell
                                          className={classes.theHeadTitle}
                                        >
                                          Phone
                                        </TableCell>
                                        <TableCell
                                          className={classes.theHeadTitle}
                                        >
                                          Reason
                                        </TableCell>
                                        <TableCell
                                          className={classes.theHeadTitle}
                                        >
                                          Memo
                                        </TableCell>
                                        <TableCell
                                          className={classes.theHeadTitle}
                                        >
                                          Status
                                        </TableCell>
                                        <TableCell
                                          className={classes.theHeadTitle}
                                        >
                                          Images
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{
                                            borderRadius: "0 10px 10px 0",
                                          }}
                                          className={classes.theHeadTitle}
                                        ></TableCell>
                                      </TableRow> */}

                                      <TableRow>
                                        <TableCell
                                          className={classes.theHeadTitle}
                                          style={{
                                            borderRadius: "10px 0 0 10px",
                                          }}
                                        >
                                          Year - Month
                                        </TableCell>

                                        <TableCell
                                          className={classes.theHeadTitle}
                                        >
                                          Amount
                                        </TableCell>

                                        <TableCell
                                          align="center"
                                          style={{
                                            borderRadius: "0 10px 10px 0",
                                          }}
                                          className={classes.theHeadTitle}
                                        ></TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {/* {listData != null &&
                                        listData
                                          .slice(
                                            pageNum * 10,
                                            pageNum * 10 + 10
                                          )
                                          .map((item, index) => {
                                            return (
                                              <TableRow>
                                             
                                                <TableCell
                                                  className={
                                                    classes.theUnderLineLabel
                                                  }
                                                  style={{
                                                    textDecoration: "underline",
                                                    // width: "20%"
                                                  }}
                                                  onClick={() =>
                                                    navigate(
                                                      "/salereturn/" +
                                                        item.sales_order_id +
                                                        "/" +
                                                        item.sales_order_report_id
                                                    )
                                                  }
                                                >
                                                  {item.sales_order_report_id !=
                                                    "" &&
                                                  item.sales_order_report_id !=
                                                    null
                                                    ? item.sales_order_report_id
                                                    : "-"}{" "}
                                                  View &#62;
                                                </TableCell>
                                                <TableCell
                                              
                                                >
                                                  {item.sales_order_id != "" &&
                                                  item.sales_order_id != null
                                                    ? item.sales_order_id
                                                    : "-"}
                                                </TableCell>
                                                <TableCell
                                              
                                                  style={{
                                                    width: "25%",
                                                  }}
                                                >
                                                  {item.customer != "" &&
                                                  item.customer != null
                                                    ? item.customer
                                                    : "-"}
                                                </TableCell>

                                                <TableCell>
                                                  {item.phone != "" &&
                                                  item.phone != null
                                                    ? item.phone
                                                    : "-"}
                                                </TableCell>
                                                <TableCell>
                                                  {item.reason != "" &&
                                                  item.reason != null
                                                    ? item.reason
                                                    : "-"}
                                                </TableCell>
                                                <TableCell>
                                                  {item.description != "" &&
                                                  item.description != null
                                                    ? item.description
                                                    : "-"}
                                                </TableCell>
                                                <TableCell>
                                                  {item.status != "" &&
                                                  item.status != null
                                                    ? item.status
                                                    : "-"}
                                                </TableCell>
                                                <TableCell>
                                                  {item.images.length > 0 ? (
                                                    <span
                                                      onClick={() =>
                                                        handleOpenVariantImage(
                                                          item.images
                                                        )
                                                      }
                                                      style={{
                                                        textDecoration:
                                                          "underline",
                                                        color: "#1a5386",
                                                      }}
                                                    >
                                                      View &#62;
                                                    </span>
                                                  ) : (
                                                    <span
                                                      style={{
                                                        textDecoration:
                                                          "underline",
                                                        color: "#CCCCCC",
                                                      }}
                                                    >
                                                      View &#62;
                                                    </span>
                                                  )}
                                                </TableCell>
                                              </TableRow>
                                            );
                                          })} */}

                                      {listData != null &&
                                        listData
                                          .slice(
                                            pageNum * 10,
                                            pageNum * 10 + 10
                                          )
                                          .map((item, index) => {
                                            return (
                                              <TableRow>
                                                <TableCell>
                                                  {item.month != "" &&
                                                  item.month != null
                                                    ? item.month
                                                    : "-"}
                                                </TableCell>

                                                <TableCell>
                                                  {item.amount != "" &&
                                                  item.amount != null
                                                    ? item.amount
                                                    : "-"}
                                                </TableCell>
                                              </TableRow>
                                            );
                                          })}
                                    </TableBody>
                                  </Table>
                                </TableContainer>

                                <div
                                  style={{
                                    borderTop: "1px solid #707070",
                                    borderBottom: "1px solid #707070",
                                    margin: "1rem 0 0",
                                    cursor: "pointer",
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    alignItems: "flex-end",
                                  }}
                                >
                                  <TablePagination
                                    // variant="outlined"
                                    color="primary"
                                    page={pageNum}
                                    onPageChange={handleChangePageSaleReport}
                                    count={totalListSaleReport}
                                    // defaultPage={pageList}
                                    rowsPerPage={10}
                                    rowsPerPageOptions={[10]}
                                    // count={10}
                                  />
                                </div>
                              </Card>
                              <br />
                              <br />
                            </Grid>
                          </Grid>
                          <br />
                          <br />

                          {imageData != null && (
                            <Dialog
                              onClose={handleCloseVariantImage}
                              open={openVariantImg}
                              fullWidth="true"
                              maxWidth="xl"
                            >
                              <DialogTitle>
                                <Paragraph
                                  color="#1A5386"
                                  bold="600"
                                  size="24px"
                                >
                                  Attached Images
                                </Paragraph>
                              </DialogTitle>
                              <DialogContent>
                                <br />
                                <div className={classes.theSliderVariant}>
                                  <Slider
                                    dots={true}
                                    speed={500}
                                    slidesToShow={4}
                                    slidesToScroll={4}
                                    infinite={infiniteStatus}
                                  >
                                    {imageData.map((res) => (
                                      <div>
                                        <div className={classes.theImageBox}>
                                          <div className={classes.theIBImg}>
                                            <img src={res.image} />
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                  </Slider>
                                </div>
                                <br />
                              </DialogContent>
                            </Dialog>
                          )}
                        </div>
                      </>
                    )}
                    {window.localStorage.getItem("page") ==
                      "Statement Account" && (
                      <Card className={classes.theCard_}>
                        <div className={classes.theCHeader}>
                          <Paragraph
                            color="#000"
                            bold="600"
                            size="16px"
                            // margin="0 0 1rem"
                          >
                            Statement Account
                          </Paragraph>
                        </div>
                        <div className={classes.theCBody}>
                          <Paragraph size="20px" bold="600" color="#878787">
                            Please select desire month & year to print your
                            Statement
                          </Paragraph>
                          <Paragraph margin=" 1rem 0">
                            Select Month{" "}
                            <span
                              style={{ color: "#F92000", marginLeft: "4px" }}
                            >
                              *
                            </span>
                          </Paragraph>
                          <FormInputSelect>
                            <Select
                              displayEmpty
                              inputProps={{ "aria-label": "Without label" }}
                              value={chooseMonth}
                              onChange={handleChooseMonth}
                              style={{ marginBottom: "1rem" }}
                            >
                              <MenuItem value="" style={{ fontWeight: "400" }}>
                                <em style={{ color: "#878787" }}>
                                  Please select a month
                                </em>
                              </MenuItem>
                              <MenuItem value="01" style={{ color: "#000" }}>
                                January
                              </MenuItem>
                              <MenuItem value="02" style={{ color: "#000" }}>
                                February
                              </MenuItem>
                              <MenuItem value="03" style={{ color: "#000" }}>
                                March
                              </MenuItem>
                              <MenuItem value="04" style={{ color: "#000" }}>
                                April
                              </MenuItem>
                              <MenuItem value="05" style={{ color: "#000" }}>
                                May
                              </MenuItem>
                              <MenuItem value="06" style={{ color: "#000" }}>
                                June
                              </MenuItem>
                              <MenuItem value="07" style={{ color: "#000" }}>
                                July
                              </MenuItem>
                              <MenuItem value="08" style={{ color: "#000" }}>
                                August
                              </MenuItem>
                              <MenuItem value="09" style={{ color: "#000" }}>
                                September
                              </MenuItem>
                              <MenuItem value="10" style={{ color: "#000" }}>
                                October
                              </MenuItem>
                              <MenuItem value="11" style={{ color: "#000" }}>
                                November
                              </MenuItem>
                              <MenuItem value="12" style={{ color: "#000" }}>
                                December
                              </MenuItem>
                            </Select>
                          </FormInputSelect>

                          <Paragraph margin="0 0 1rem 0">
                            Select Year{" "}
                            <span
                              style={{ color: "#F92000", marginLeft: "4px" }}
                            >
                              *
                            </span>
                          </Paragraph>
                          <FormInputSelect>
                            <Select
                              displayEmpty
                              inputProps={{ "aria-label": "Without label" }}
                              value={chooseYear}
                              onChange={handleChooseYear}
                              style={{ marginBottom: "1rem" }}
                            >
                              <MenuItem value="" style={{ fontWeight: "400" }}>
                                <em style={{ color: "#878787" }}>
                                  Please select a year
                                </em>
                              </MenuItem>
                              <MenuItem value="2020" style={{ color: "#000" }}>
                                2020
                              </MenuItem>
                              <MenuItem value="2021" style={{ color: "#000" }}>
                                2021
                              </MenuItem>
                              <MenuItem value="2022" style={{ color: "#000" }}>
                                2022
                              </MenuItem>
                              <MenuItem value="2023" style={{ color: "#000" }}>
                                2023
                              </MenuItem>
                              <MenuItem value="2024" style={{ color: "#000" }}>
                                2024
                              </MenuItem>
                              <MenuItem value="2025" style={{ color: "#000" }}>
                                2025
                              </MenuItem>
                            </Select>
                          </FormInputSelect>
                          <br />
                          <div className={classes.theSizeBtn}>
                            <Button
                              label="SUBMIT"
                              color="#fff"
                              bg="#125396"
                              bold="600"
                              hover
                              onClick={() => handleSubmit()}
                            />
                          </div>
                        </div>
                      </Card>
                    )}
                    <br />
                    <br />
                  </div>

                  <Dialog
                    onClose={handleClose}
                    open={open}
                    fullWidth="true"
                    maxWidth="sm"
                  >
                    <DialogTitle>
                      <Paragraph color="#1A5386" bold="600" size="24px">
                        Edit Address
                      </Paragraph>
                    </DialogTitle>
                    <DialogContent>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={4} md={6}>
                          <FormInput
                            label="Contact Name*"
                            value={addressData.contact_name}
                            textLabelColor="#000"
                            placeholder="Contact Name"
                            name="contact_name"
                            border="1px solid #c5c5c5"
                            onChange={handleChangeAddress}
                            mb="0"
                          />
                        </Grid>
                        <Grid item xs={12} sm={4} md={6}>
                          <FormInput
                            label="Contact Number*"
                            value={addressData.contact_number}
                            textLabelColor="#000"
                            placeholder="Contact Number"
                            name="contact_number"
                            type="number"
                            border="1px solid #c5c5c5"
                            onChange={handleChangeAddress}
                            mb="0"
                          />
                        </Grid>
                        <Grid item xs={12} sm={4} md={6}>
                          <FormInput
                            label="Address 1*"
                            value={addressData.addr1}
                            textLabelColor="#000"
                            placeholder="Address 1"
                            name="addr1"
                            border="1px solid #c5c5c5"
                            onChange={handleChangeAddress}
                            mb="0"
                          />
                        </Grid>
                        <Grid item xs={12} sm={4} md={6}>
                          <FormInput
                            label="Address 2*"
                            value={addressData.addr2}
                            textLabelColor="#000"
                            placeholder="Address 2"
                            name="addr2"
                            border="1px solid #c5c5c5"
                            onChange={handleChangeAddress}
                            mb="0"
                          />
                        </Grid>
                        <Grid item xs={12} sm={4} md={6}>
                          <FormInput
                            label="City*"
                            value={addressData.city}
                            textLabelColor="#000"
                            placeholder="City"
                            name="city"
                            border="1px solid #c5c5c5"
                            onChange={handleChangeAddress}
                            mb="0"
                          />
                        </Grid>
                        <Grid item xs={12} sm={4} md={6}>
                          <FormInput
                            label="Zipcode*"
                            value={selectedState.zip}
                            textLabelColor="#000"
                            placeholder="Zipcode"
                            name="zip"
                            border={
                              zipStatusEdit
                                ? "1px solid #C52626"
                                : "1px solid #c5c5c5"
                            }
                            onChange={handleCheckValid}
                            mb="0"
                          />
                          {zipStatusEdit && (
                            <Paragraph margin="4px 0 0" color="#C52626">
                              Warning
                            </Paragraph>
                          )}
                        </Grid>

                        <Grid item xs={12} sm={4} md={6}>
                          <FormInput
                            label="State*"
                            name="state"
                            value={selectedState.state}
                            onChange={handleCheckValid}
                            style={{ marginBottom: "1rem" }}
                            select
                            border={
                              zipStatusEdit
                                ? "1px solid #C52626"
                                : "1px solid #c5c5c5"
                            }
                          >
                            <MenuItem value="" style={{ fontWeight: "400" }}>
                              <em style={{ color: "#878787" }}>
                                Please Choose a State
                              </em>
                            </MenuItem>
                            {stateData.map((item) => (
                              <MenuItem
                                value={item.name}
                                style={{ color: "#000" }}
                              >
                                {item.name}
                              </MenuItem>
                            ))}
                          </FormInput>
                          {zipStatusEdit && (
                            <Paragraph margin="4px 0 0" color="#C52626">
                              Warning
                            </Paragraph>
                          )}
                        </Grid>

                        <Grid item xs={12} sm={4} md={6}>
                          <FormInput
                            label="Country*"
                            value={addressData.country}
                            textLabelColor="#000"
                            placeholder="Country"
                            name="country"
                            border="1px solid #c5c5c5"
                            onChange={handleChangeAddress}
                            select
                            mb="0"
                          >
                            <MenuItem
                              value={0}
                              disabled
                              style={{ color: "#000" }}
                            >
                              Please Select Country
                            </MenuItem>
                            {countryData.length != 0 &&
                              countryData.map((res) => (
                                <MenuItem
                                  value={res.name}
                                  style={{ color: "#000" }}
                                  // onClick={handleChangeAddress}
                                >
                                  {res.name}
                                </MenuItem>
                              ))}
                          </FormInput>
                        </Grid>
                      </Grid>
                      <Button
                        onClick={() => handleSaveAddress()}
                        label="Save"
                        color="#fff"
                        bg="#1A5386"
                        size="18px"
                        pd="10px"
                        br="5px"
                        style={{ margin: "10px 0" }}
                      />
                    </DialogContent>
                  </Dialog>

                  <Dialog
                    onClose={handleCloseAdd}
                    open={openAdd}
                    fullWidth="true"
                    maxWidth="sm"
                  >
                    <DialogTitle>
                      <Paragraph color="#1A5386" bold="600" size="24px">
                        Add Address
                      </Paragraph>
                    </DialogTitle>
                    <DialogContent>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={4} md={6}>
                          <FormInput
                            label="Contact Name*"
                            value={addressAddData.contact_name}
                            textLabelColor="#000"
                            placeholder="Contact Name"
                            name="contact_name"
                            border="1px solid #c5c5c5"
                            onChange={handleChangeAddAddress}
                            mb="0"
                          />
                        </Grid>
                        <Grid item xs={12} sm={4} md={6}>
                          <FormInput
                            label="Contact Number*"
                            value={addressAddData.contact_number}
                            textLabelColor="#000"
                            placeholder="Contact Number"
                            name="contact_number"
                            type="number"
                            border="1px solid #c5c5c5"
                            onChange={handleChangeAddAddress}
                            mb="0"
                          />
                        </Grid>
                        <Grid item xs={12} sm={4} md={6}>
                          <FormInput
                            label="Address 1*"
                            value={addressAddData.addr1}
                            textLabelColor="#000"
                            placeholder="Address 1"
                            name="addr1"
                            border="1px solid #c5c5c5"
                            mb="0"
                            onChange={handleChangeAddAddress}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4} md={6}>
                          <FormInput
                            label="Address 2*"
                            value={addressAddData.addr2}
                            textLabelColor="#000"
                            placeholder="Address 2"
                            name="addr2"
                            border="1px solid #c5c5c5"
                            mb="0"
                            onChange={handleChangeAddAddress}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4} md={6}>
                          <FormInput
                            label="City*"
                            value={addressAddData.city}
                            textLabelColor="#000"
                            placeholder="City"
                            name="city"
                            border="1px solid #c5c5c5"
                            mb="0"
                            onChange={handleChangeAddAddress}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4} md={6}>
                          <FormInput
                            label="Zipcode*"
                            value={addressAddData.zip}
                            textLabelColor="#000"
                            placeholder="Zipcode"
                            name="zip"
                            border={
                              zipStatus
                                ? "1px solid #C52626"
                                : "1px solid #c5c5c5"
                            }
                            mb="0"
                            onChange={handleChangeAddAddress}
                          />
                          {zipStatus && (
                            <Paragraph margin="4px 0 0" color="#C52626">
                              Warning
                            </Paragraph>
                          )}
                        </Grid>
                        <Grid item xs={12} sm={4} md={6}>
                          <FormInput
                            label="State*"
                            value={addressAddData.state}
                            textLabelColor="#000"
                            placeholder="State"
                            name="state"
                            border={
                              zipStatus
                                ? "1px solid #C52626"
                                : "1px solid #c5c5c5"
                            }
                            onChange={handleChangeAddAddress}
                            mb="0"
                            select
                          >
                            <MenuItem
                              value={0}
                              disabled
                              style={{ color: "#000" }}
                            >
                              Please Select State
                            </MenuItem>
                            {stateData.length != 0 &&
                              stateData.map((res) => (
                                <MenuItem
                                  value={res.name}
                                  style={{ color: "#000" }}
                                  // onClick={handleChangeAddress}
                                >
                                  {res.name}
                                </MenuItem>
                              ))}
                          </FormInput>
                          {zipStatus && (
                            <Paragraph margin="4px 0 0" color="#C52626">
                              Warning
                            </Paragraph>
                          )}
                        </Grid>
                        <Grid item xs={12} sm={4} md={6}>
                          <FormInput
                            label="Country*"
                            value={addressAddData.country}
                            textLabelColor="#000"
                            placeholder="Country"
                            name="country"
                            border="1px solid #c5c5c5"
                            onChange={handleChangeAddAddress}
                            mb="0"
                            select
                          >
                            <MenuItem
                              value={0}
                              disabled
                              style={{ color: "#000" }}
                            >
                              Please Select Country
                            </MenuItem>
                            {countryData.length != 0 &&
                              countryData.map((res) => (
                                <MenuItem
                                  value={res.name}
                                  style={{ color: "#000" }}
                                  // onClick={handleChangeAddAddress}
                                >
                                  {res.name}
                                </MenuItem>
                              ))}
                          </FormInput>
                        </Grid>
                      </Grid>
                      <Button
                        onClick={() => handleAddAddress()}
                        label="Add"
                        color="#fff"
                        bg="#1A5386"
                        size="18px"
                        pd="10px"
                        br="5px"
                        style={{ margin: "10px 0" }}
                      />
                    </DialogContent>
                  </Dialog>

                  <Dialog
                    onClose={handleCloseDelete}
                    open={openDelete}
                    fullWidth="true"
                    maxWidth="sm"
                  >
                    <DialogTitle>
                      <Paragraph color="#1A5386" bold="600" size="24px">
                        Delete Address
                      </Paragraph>
                    </DialogTitle>
                    <DialogContent>
                      <Paragraph
                        color="#000"
                        bold="600"
                        size="16px"
                        margin="0 0 1rem"
                      >
                        Are you sure to delete this address?
                      </Paragraph>
                      <Button
                        onClick={() => handleDeleteAddress()}
                        label="Save"
                        color="#fff"
                        bg="#1A5386"
                        size="18px"
                        pd="10px"
                        br="5px"
                        style={{ marginBottom: "10px" }}
                      />
                    </DialogContent>
                  </Dialog>
                </Section>
              }
            />
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  );
}
